import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const ThemeApplier = () => {
  const theme = useSelector(state => state.theme.values);

  useEffect(() => {
    Object.keys(theme).forEach((key) => {
      document.documentElement.style.setProperty(`--${key}`, theme[key]);
    });
  }, [theme]);

  return null;
};

export default ThemeApplier;
